import { StockLocationEntity } from '../common/entity';
import { WithCustomFields } from '../custom_field/customField';
import { applyMixins } from '../../util/mixins';

export const SystemBin = {
  id: '00000000-0000-0000-0000-000000000001',
  stockLocationId: '00000000-0000-0000-0000-000000000001',
  binStatusId: '00000000-0000-0000-0000-000000000001',
  name: 'SYSTEM',
};

export class Bin extends StockLocationEntity {
  name!: string;
  binStatusId!: string;

  constructor(obj: any) {
    if (!obj.companyId || !obj.stockLocationId) return;
    super(obj.companyId, obj.stockLocationId);
    Object.assign(this, obj);
    this.customFields = WithCustomFields.toCustomFieldsMap(obj);
  }
}

export interface Bin extends WithCustomFields {}
applyMixins(Bin, [Bin, WithCustomFields]);
